import { useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { db } from "../../firebase/firebase";
import { getDocs, collection, query, limit, where } from "firebase/firestore";
import { QueryKeys } from "config/query-keys";
import { QueryParamsConfig } from "hooks/useFilterPagination";
import { GetRecruiterJobsInterface, JobInterface } from "./dto";

const getJobsByRecruiter = async (
  params: QueryParamsConfig
): Promise<GetRecruiterJobsInterface> => {
  try {
    const { page = 1, pageSize = 20, recruiterId } = params;
    const jobCollectionRef = collection(db, "jobs");

    let jobQuery = query(jobCollectionRef, where("recruiter", "==", recruiterId), limit(pageSize + 1));

    const rawData = await getDocs(jobQuery);

    const jobs: JobInterface[] = rawData.docs.slice(0, pageSize).map((doc) => {
      const data = doc.data();

      return {
        ...data,
        id: doc.id,
        deadlineAt: data.deadlineAt ? data.deadlineAt.toDate() : new Date(),
        createdAt: data.createdAt ? data.createdAt.toDate() : new Date(),
      };
    });

    const hasMore = rawData.docs.length > pageSize;

    return {
      data: jobs,
      page,
      pageSize,
      totalData: jobs.length,
      isLastPage:!hasMore,
    };
  } catch (error) {
    console.error("Error fetching jobs:", error);
    throw error;
  }
};


export const useGetJobsByRecruiter = (params: QueryParamsConfig) => {
  const {
    findByDistrict,
    findByJobType,
    findByMunicipality,
    findByProvince,
    findByWard,
    searchBy,
    page,
    pageSize,
    isLastPage,
  } = params;

  const query = useQuery<GetRecruiterJobsInterface, AxiosError>({
    queryKey: [
      QueryKeys.JOBS,
      findByDistrict,
      findByJobType,
      findByMunicipality,
      findByProvince,
      findByWard,
      searchBy,
      page,
      pageSize,
      isLastPage,
    ],
    queryFn: () => getJobsByRecruiter(params),
    staleTime: 1000 * 60 * 5,
  });

  return query;
};
